// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle_subtitle__WiXjU","subtitle--small":"Subtitle_subtitle--small__ivlyf"};